import type { AdminAction } from './admin';
import type { AppStateAction } from './app';
import type { AskAlphaAction } from './askAlpha';
import type { AuthAction } from './auth';
import type { ContainerAction } from './container';
import type { FeatureFlagAction } from './featureFlags';
import type { LayoutAction } from './layout';
import type { LocatePreferencesAction } from './locates/locatePreferences';
import type { LocatesAction } from './locates/locates';
import type { LocatesSocketAction } from './locates/locatesSocket';
import type { NativeAction } from './native';
import type { NavigationAction } from './navigation';
import type { OnboardingAction } from './onboarding';
import type { OverlayAction } from './overlay';
import type { RecentlyUsedIndicatorsAction } from './recentlyUsedIndicators';
import type { TabAction } from './tab';
import type { ThemeAction } from './theme';
import type { ToastAction } from './toast';
import type { UIAction } from './ui';
import type { WidgetAndChannelAction } from './widgetAndChannel';
import type { WidgetOperationActions } from './widgets';
import type { WorkspaceAction } from './workspace';
import { CALL_HISTORY_METHOD } from 'redux-first-history';
import type { RouterActions } from 'redux-first-history';

type AppActionBase =
    | AdminAction
    | AppStateAction
    | AskAlphaAction
    | AuthAction
    | ContainerAction
    | FeatureFlagAction
    | LayoutAction
    | LocatesAction
    | LocatesSocketAction
    | LocatePreferencesAction
    | NavigationAction
    | NativeAction
    | OnboardingAction
    | OverlayAction
    | RecentlyUsedIndicatorsAction
    | RouterActions
    | TabAction
    | ThemeAction
    | ToastAction
    | UIAction
    | WidgetAndChannelAction
    | WorkspaceAction
    | WidgetOperationActions;

export const intentBasedActionTypes: AppActionBase['type'][] = [
    CALL_HISTORY_METHOD,
    'workspace-template-library::open',
    'saveWorkspaceEvent',
    'createBlankWorkspaceEvent',
    'createFromTemplateLibraryEvent',
];

// Actions may have additional metadata attached to them
export interface AppActionMeta {
    meta?: {
        /**
         * The webContentsId of the renderer that dispatched the action
         */
        webContentsId?: number;
    };
    isIntentConfirmed?: boolean;
}

export type AppAction = AppActionBase & AppActionMeta;
export type VerifyIntentAction<T extends AppAction> = { type: 'verifyIntentAction'; originalAction: T };
